
export function getCurrentDubaiDate (): Date {
    const dubaiTimezoneOffset = 4 * 60 // Временная зона Дубая в минутах (UTC+4)
    const now = new Date()
    const currentUtcTime = now.getTime() + (now.getTimezoneOffset() * 60000) // Текущее UTC время
    const dubaiCurrentUtcTime = currentUtcTime + (dubaiTimezoneOffset * 60000) // Текущее UTC время в Дубае
    const dubaiDate = new Date(dubaiCurrentUtcTime)
    return dubaiDate
}
